export default __webpack_public_path__ + "static/bannerCar-44079f56c74645138220bdcfd7fcf8f6.png";